export const Colors = {
  LightBlue: "#54c0f2",
  LightGrey: "#d4d4d4",
  TypeBlack: "#202020",
};
